import { TableRow } from '@mui/material'
import { TableCellWidth } from '@app/src/components/Table'
import TableHeaderCell from '@app/src/components/Table/Cells/TableHeaderCell'
import React from 'react'
import { useIntl } from 'react-intl'

const ProviderCommentHeader: React.FC = () => {
  const { formatMessage } = useIntl()

  return (
    <TableRow>
      <TableHeaderCell label={formatMessage({ id: 'resourceExplorer.activity.comments' })} />
      <TableHeaderCell label={formatMessage({ id: 'resourceExplorer.activity.commentDate' })} />
      <TableHeaderCell label={formatMessage({ id: 'resourceExplorer.activity.commentBy' })} />
      <TableHeaderCell label="" minWidth={TableCellWidth.EMPTY} />
    </TableRow>
  )
}

export default ProviderCommentHeader
